import { Box, Flex } from '@chakra-ui/react'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import BrandMark from '@/components/Icons/BrandMark'
import ShwLink from '@/components/ShwLink'

import { navHeight } from './styled'

const SimplifiedNavbar: React.FC = () => (
  <Box
    height={navHeight}
    bg="bg"
    borderBottom={`2px solid ${chakraTokenToVar('border.emphasized')}`}
    position="relative"
  >
    <Flex
      alignItems="center"
      height="100%"
      py={0}
      px={{ base: '16px', lg: '24px' }}
      justifyContent={{ base: 'space-between', lg: 'normal' }}
    >
      <Flex
        alignItems="center"
        position="absolute"
        left="70px"
        right="70px"
        justify="center"
        top="2px"
        height="100%"
        display="flex"
      >
        <ShwLink href="/">
          <Box>
            <BrandMark height={28} textColor="primary.solid" />
          </Box>
        </ShwLink>
      </Flex>
    </Flex>
  </Box>
)

export default SimplifiedNavbar
